import { forwardRef, useState } from 'react';
import { SensitiveInfoAdornment, TextField, type TextFieldProps } from '@huntington/honeycomb';

/**
 * A specialized TextField component that masks the input
 */
export const PasswordInput = forwardRef<HTMLDivElement, TextFieldProps>((props, ref) => {
	const [isHidden, setIsHidden] = useState(true);

	const toggleHide = () => {
		setIsHidden(!isHidden);
	};

	const inputType = isHidden ? 'password' : 'text';
	const showSensitiveInfoAdornment = !!props.value;

	return (
		<TextField
			{...props}
			InputProps={{
				endAdornment: (
					
						<SensitiveInfoAdornment
							aria-label={isHidden ? 'show text' : 'hide text'}
							onClick={toggleHide}
							// iconPosition={'none'} // need to update to honeycomb v0.30.0
							show={showSensitiveInfoAdornment}
						>
							{isHidden ? 'Show' : 'Hide'}
						</SensitiveInfoAdornment>
					
				),
			}}
			type={inputType}
			ref={ref}
		/>
	);
});
PasswordInput.displayName = 'PasswordInput';
